import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import BCVantaihanghoa from "components/Baocao/Vantaihanghoa/BCVantaihanghoa.js";
export default function BCVantai() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Vận tải hàng hóa",
            tabContent: <BCVantaihanghoa />,
          },
        ]}
      />
    </div>
  );
}
